import React from 'react';
import Figure from './figures/Figure';

import MembersQuery from '../model/Members';
import ProjectQuery from '../model/Projects';
import { useI18n } from '../i18n/I18nContext';

function Figures() {
  const { t } = useI18n();
  const since = 2010;
  const members = MembersQuery({filter: 'internal'});
  const projects = ProjectQuery();
  
  return (
    <section id="chiffres" className="relative overflow-x-clip py-[2.5rem] px-10">
      <div className="flex max-w-[1200px] mx-auto relative z-20">
        <div className="flex flex-wrap w-full justify-center mx-10">
          <Figure position={0} amount={members.length} title={t("home.figures.collaborators")} />
          <Figure position={1} amount={new Date().getFullYear() - since} title={t("home.figures.years")} />
          <Figure position={2} amount={projects.length} title={t("home.figures.projects")} />
        </div>
      </div>
    </section>
  );
}

export default Figures;
